import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

let messaging;

const ensureMessaging = async () => {
  const supported = await isSupported().catch(() => false);
  if (!supported) return null;
  if (!messaging) {
    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  }
  return messaging;
};

export const requestNotificationPermission = async () => {
  if (typeof Notification === 'undefined') return false;
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const getFcmToken = async (serviceWorkerRegistration) => {
  const client = await ensureMessaging();
  if (!client) return null;

  const permissionGranted = await requestNotificationPermission();
  if (!permissionGranted) {
    return null;
  }

  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  return getToken(client, {
    vapidKey,
    serviceWorkerRegistration
  });
};

export const subscribeOnMessage = (handler) => {
  if (!messaging || typeof handler !== 'function') return () => {};
  const unsubscribe = onMessage(messaging, handler);
  return unsubscribe;
};

export const isMessagingSupported = async () => {
  const supported = await isSupported().catch(() => false);
  return supported;
};
